export default {"src":"/_next/static/media/Frozen Shoulder.b1924514.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};